var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-container',{staticClass:"content",attrs:{"fluid":""}},[_c('v-layout',{attrs:{"row":"","fill-height":""}},[_vm._t("imagem"),_vm._t("login")],2)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }